<template>
    <div>
        <div class="overlay" v-if="DESIGN_PROJECT_MODAL" @click="closeModal"></div>
        <section class="design-project modal" v-if="DESIGN_PROJECT_MODAL">
            <button class="modal__close" title="close" type="button" @click="closeModal">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#close"/>
                </svg>
            </button>
            <div class="design-project__inner">
                <p class="sub-title">Закажите 3D визуализацию</p>
                <p class="design-project__text">
                    Смоделируем визуализацию Вашего проекта, чтобы показать наглядность и нюансы будущего проекта.
                    <br>
                    Сфотографируйте своё окно и прикрепите фотографии к заявке
                </p>
                <div class="design-project__compare-list">
                    <a class="design-project__compare" href="/assets/img/marketing/after-full.png">
                        <span class="design-project__compare-name">
                            До
                        </span>
                        <img class="design-project__compare-img" src="/assets/img/marketing/before.jpg" alt="">
                        <span class="design-project__compare-text">Ваше фото</span>
                    </a>
                    <a class="design-project__compare _after" href="/assets/img/marketing/before-full.png">
                        <span class="design-project__compare-name">
                            После
                        </span>
                        <img class="design-project__compare-img" src="/assets/img/marketing/after.jpg" alt="">
                        <span class="design-project__compare-text">Ваше фото + визуализация</span>
                    </a>
                </div>
            </div>
            <div class="design-project__wrapper">
                <p class="sub-title"></p>
                <p class="h3 form__success" v-if="success">
                    <img class="form__success-img" src="/assets/img/other/snail.png" alt="">
                    <span class="form__success-text">
                        Заявка успешно отправлена! Мы свяжемся с Вами в ближайшее время.
                    </span>
                </p>
                <form class="form" v-if="!success" @submit.prevent="formSubmit">
                    <input-text v-model="callback.name"
                                :v="$v.callback.name"
                                placeholder="Ваше имя"
                                errorText="Укажите имя"/>
                    <input-phone v-model="callback.phone"
                                 :v="$v.callback.phone"
                                 errorText="Укажите корректный номер"
                                 placeholder="Телефон"/>
                    <div class="input">
                        <v-select :options="cities"
                                  :multiple="false"
                                  :searchable="false"
                                  v-model="callback.city"
                                  @change="$v.callback.city.$touch()"
                                  @blur="$v.callback.city.$touch()"
                                  required
                                  placeholder="Укажите область">
                        </v-select>
                        <span class="input__error" v-if="$v.callback.city.$error">Укажите область</span>
                    </div>
                    <customTextarea v-model="callback.comment"
                                    :v="$v.callback.comment"
                                    placeholder="Напишите свои комментарии"/>
                    <input-file v-model="callback.file"
                                fileInputName="callbackFile"
                                :v="$v.callback.file"/>
                    <custom-checkbox
                        :v="$v.callback.politics"
                        v-model="callback.politics"
                        :class="{_error: $v.callback.politics.$error}"
                        checkboxName="politicscallback"
                        checkboxText="Отправляя форму, Вы даёте согласие на обработку персональных данных"/>
                    <button class="btn" type="submit">Отправить</button>
                </form>
            </div>
        </section>
    </div>
</template>

<script>
import inputPhone from "../common/inputPhone";
import inputText from "../common/inputText";
import inputFile from "../common/inputFile";
import customCheckbox from "../common/custom-checkbox";
import customTextarea from "../common/customTextarea";
import {required, minLength, maxLength, sameAs} from "vuelidate/lib/validators";
import SimpleLightbox from "simple-lightbox";
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'DesignProjectModal',
    components: {inputText, inputPhone, inputFile, Inputmask, customCheckbox, customTextarea},
    data() {
        return {
            visibleForm: this.DESIGN_PROJECT_MODAL,
            currentPath: window.location.href,
            callback: {
                phone: null,
                name: null,
                city: null,
                file: null,
                recaptcha: null,
                url: null,
                comment: null,
                type: 'visualization',
                politics: true
            },
            cities: this.$store.state.cities,
            success: false,
        }
    },
    validations: {
        callback: {
            name: {
                required,
                minLength: minLength(2)
            },
            city: {required},
            comment: {},
            file: {},
            politics: {
                sameAs: sameAs(() => true)
            },
            phone: {
                required,
                minLength: minLength(18),
                maxLength: maxLength(18),
                correctAddress(phone) {
                    return /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(phone)
                }
            }
        }
    },
    mounted() {
        window.addEventListener("load", function (event) {
            let lightbox = new SimpleLightbox({elements: '.design-project__compare'});
        });
    },
    methods: {
        ...mapActions({
            GET_DESIGN_PROJECT: 'GET_DESIGN_PROJECT',
        }),
        formSubmit() {
            this.$v.callback.$touch();
            if (this.$v.callback.$pending && this.$v.callback.$error) {
            } else {
                this.recaptcha().then(token => {
                    this.$cookies.set("designProject", true, 60 * 60 * 24 * 2);
                    this.callback.recaptcha = token;
                    this.callback.url = window.location.href;
                    this.success = true;
                    this.$http.post('/api/forms/callback', this.callback)
                        .then(res => {
                            ym(1980352, 'reachGoal', 'designOrder')
                        })
                });
            }
        },
        closeModal() {
            this.GET_DESIGN_PROJECT(false);
            this.$cookies.set("designProject", true, 60 * 60 * 24 * 2);
            document.body.classList.remove('_no-scroll');
        },
    },
    computed: {
        ...mapGetters({
            ACTIVE_CITY: 'cityName',
            DESIGN_PROJECT_MODAL: 'designProjectModalStatus'
        }),
    }
}
</script>

<style scoped lang="scss">
.overlay {
    display: block;
}
</style>
